// @ts-nocheck
import { useWindowContext } from "@toolkit/Framework/Components/WindowContext";
import findLastIndex from "lodash/findLastIndex";
import { useTheme } from "styled-components";

export default () => {
    const theme = useTheme();
    const { clientWidth } = useWindowContext();

    if (typeof document === "undefined" || !clientWidth) {
        return 0;
    }

    const breakpointIndex = findLastIndex(theme.breakpoints.values, x => clientWidth >= x);

    return breakpointIndex;
};
